/** biome-ignore-all lint/style/noMagicNumbers: TODO: refactor */

import { isMockUsed } from '@nvision/services/mock';
import rgbHex from 'rgb-hex';

import { ENV_VARS } from '@/env';

import { SHIPMENT_NO_HIDE_STATUSES, USER_PREFERENCES } from '../contants/common';
import { filterNullishFromObject } from './format';

export const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

export const getStyleVariableValue = (key) => window.getComputedStyle(document.documentElement).getPropertyValue(key);

export const getPrimaryMenu = (menus) => {
  const getModifiedMenu = (localMenus = []) => {
    return isHBUser
      ? localMenus
      : [
          ...menus,
          isMockUsed() && {
            menuName: 'Pricing',
            menuText: 'Pricing',
            navigationID: 148,
            parentID: 0,
          },
          isMockUsed() && {
            menuName: 'Contract Management',
            menuText: 'Contract Management',
            navigationID: 149,
            parentID: 0,
          },
          isMockUsed() && {
            menuName: 'Procurement New',
            menuText: 'Procurement New',
            navigationID: 151,
            parentID: 0,
          },
          {
            menuName: 'Settings',
            menuText: 'Settings',
            navigationID: 60,
            parentID: 6,
            subMenus: [
              {
                menuName: 'TMSSettings',
                menuText: 'TMS Settings',
              },
            ],
          },
        ].filter(Boolean);
  };

  if (menus?.length > 0) {
    let parentMenu = menus.filter(({ parentID }) => !parentID);
    parentMenu = parentMenu.map((row) => ({
      ...row,
      subMenus: menus.filter(({ parentID }) => parentID === row.navigationID),
    }));

    // biome-ignore lint/style/noParameterAssign: TODO: fix
    menus = parentMenu;
  } else {
    // biome-ignore lint/style/noParameterAssign: TODO: fix
    menus = [];
  }

  return getModifiedMenu(menus).map((row) => ({
    ...row,
    hasSubMenu: Boolean(row?.subMenus?.length),
  }));
};

export const defaultPoStatusString = (val) => (val ? String(val) : 'O');

export const isRequiredField = (data) => Boolean(data?.find((item) => item.required));

export const getRateShopStringAll = (val) => (val && String(val).toLocaleUpperCase() !== 'ALL' ? val : '**');

export const calCulateFreightClass = (
  varLength,
  varWidth,
  varHeight,
  VarTotalWeight,
  VarWeightUOM,
  varTotalBilledQty,
  _VarBilledQtyUOM,
  varDimUOM,
  varTotalCube,
  varIsCmsAllowed,
) => {
  //Assuming All length width weightUOM BilledQtyUOm DimUOM should be same

  let ProductUom = '';
  let ProductWeightUom = '';
  //Inches
  let ProductLengthInches = 0;
  let ProductHeightInches = 0;
  let ProductWidthInches = 0;

  //Inches

  //Feet
  let ProductLengthFeet = 0;
  let ProductHeightFeet = 0;
  let ProductWidthFeet = 0;

  //Feet

  //Feet
  let ProductLengthCentimeter = 0;
  let ProductHeightCentimeter = 0;
  let ProductWidthCentimeter = 0;

  //Feet

  let SumProductLength = 0;
  let SumProductHeight = 0;
  let SumProductWidth = 0;

  // biome-ignore lint/correctness/noUnusedVariables: TODO: fix
  let ProductQuantity = 0;
  let NumOfCube = 0;
  let NumOfCubeTotal = 0;

  let ProductWeight = 0;
  let TotalProductWeight = 0;
  let TotalBilledQuantity = 0;

  ProductUom = varDimUOM;
  ProductQuantity = varTotalBilledQty;
  ProductWeight = VarTotalWeight;

  ProductWeightUom = VarWeightUOM;

  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (ProductUom == 'FT') {
    ProductLengthFeet = varLength;
    ProductHeightFeet = varHeight;
    ProductWidthFeet = varWidth;
    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  } else if (ProductUom == 'C' || ProductUom == 'CM') {
    ProductLengthCentimeter = varLength;
    ProductHeightCentimeter = varHeight;
    ProductWidthCentimeter = varWidth;
    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  } else if (ProductUom == 'N' || ProductUom == 'IN') {
    ProductLengthInches = varLength;
    ProductHeightInches = varHeight;
    ProductWidthInches = varWidth;
  }

  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (ProductWeight == '') {
    return 0;
  }
  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (ProductUom == '') {
    return 0;
  }
  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (varIsCmsAllowed != 'Y') {
    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
    if (ProductUom != 'FT') {
      // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
      if (ProductUom != 'N') {
        return 0;
      }
    }
  }
  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (ProductWeightUom == '') {
    return 0;
  }
  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (ProductWeightUom != 'KG') {
    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
    if (ProductWeightUom != 'LB') {
      return 0;
    }
  }

  // }

  SumProductHeight =
    Number.parseFloat(ProductHeightFeet) +
    Number.parseFloat(ProductHeightInches / 12) +
    Number.parseFloat(ProductHeightCentimeter * 0.0328084);
  SumProductLength =
    Number.parseFloat(ProductLengthFeet) +
    Number.parseFloat(ProductLengthInches / 12) +
    Number.parseFloat(ProductLengthCentimeter * 0.0328084);
  SumProductWidth =
    Number.parseFloat(ProductWidthFeet) +
    Number.parseFloat(ProductWidthInches / 12) +
    Number.parseFloat(ProductWidthCentimeter * 0.0328084);

  NumOfCube = SumProductHeight * SumProductLength * SumProductWidth;
  NumOfCubeTotal = NumOfCube;
  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (ProductWeightUom == 'KG') {
    ProductWeight = Number.parseFloat(ProductWeight) * 2.205;
  }
  TotalProductWeight = ProductWeight;
  TotalBilledQuantity = varTotalBilledQty;

  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (TotalBilledQuantity == '') {
    return;
  }
  if (NumOfCubeTotal > 0) {
    /* empty */
  } else {
    NumOfCubeTotal = 0;
  }

  //All Calculated in Pound
  //NumOfCubeTotal = TotalBilledQuantity * NumOfCubeTotal;
  NumOfCubeTotal = varTotalCube;
  let Density = 0;
  Density = Number.parseFloat(TotalProductWeight) / Number.parseFloat(NumOfCubeTotal);

  let FreightClass = 0;
  if (Density > 0 && Density < 1) {
    FreightClass = 400;
  } else if (Density > 1 && Density < 2) {
    FreightClass = 300;
  } else if (Density > 2 && Density < 4) {
    FreightClass = 250;
  } else if (Density > 4 && Density < 6) {
    FreightClass = 175;
  } else if (Density > 6 && Density < 8) {
    FreightClass = 125;
  } else if (Density > 8 && Density < 10) {
    FreightClass = 100;
  } else if (Density > 10 && Density < 12) {
    FreightClass = 92.5;
  } else if (Density > 12 && Density < 15) {
    FreightClass = 85;
  } else if (Density >= 15) {
    FreightClass = 70;
  }

  return FreightClass;
};

export const validateProductForCalculateClass = (products, isHideTheRowDetails = false) => {
  return new Promise((resolve, reject) => {
    if (products) {
      products.forEach(({ dimUom }, index) => {
        if (!dimUom) {
          reject(`Dimensions Unit Of Measure is required${!isHideTheRowDetails ? ` In product ${index + 1}` : ''}.`);
        }
        if (!['FT', 'N'].includes(dimUom)) {
          reject(
            `Dimensions Unit Of Measure should be Feet/Inches Only${
              !isHideTheRowDetails ? ` In product ${index + 1}` : ''
            }.`,
          );
        }
      });
      resolve(true);
    } else {
      reject('Invalid products information!');
    }
  });
};

export const validateProductForCalculateClassQuote = (products, isHideTheRowDetails = false) => {
  return new Promise((resolve, reject) => {
    if (products) {
      products.forEach(({ dimUom }, index) => {
        if (!dimUom) {
          reject(`Dimensions Unit Of Measure is required${!isHideTheRowDetails ? ` In product ${index + 1}` : ''}.`);
        }
      });
      resolve(true);
    } else {
      reject('Invalid products information!');
    }
  });
};

export const filterRateShopAdditionalFieldsVersionTwo = (data, filterData, accessor = 'codeDesc') => {
  let filteredList = [];
  let listForClearState = [];
  const selectedList = data?.filter((item) => item.isChecked);
  if (filterData?.searchValue && filterData?.searchValue?.length > 0) {
    if (filterData.filterType === 'START') {
      const regex = new RegExp(`^${filterData?.searchValue}`, 'gi');
      filteredList = data?.filter(({ [accessor]: recordValue }) => regex.test(recordValue) || regex.test(recordValue));
    } else {
      filteredList = data?.filter((row) => row[accessor] === filterData.searchValue);
    }
  } else {
    listForClearState = data?.filter(
      ({ lookupKey }) => selectedList.findIndex((item) => item.lookupKey === lookupKey) === -1,
    );
  }
  filteredList = filteredList?.filter(
    ({ lookupKey }) => selectedList?.findIndex((item) => item.lookupKey === lookupKey) === -1,
  );
  return [...filteredList, ...selectedList, ...listForClearState];
};

export const rgbaToHex = (rgba) => rgbHex(rgba?.r, rgba?.g, rgba?.b, rgba?.a);

// Need to enable this feature for admin users only later
const omitCssVariables = ['header', 'topMenuText', 'dark-1', 'bottomMenuText', 'font-family'];
export const applyTheme = (cssVariables) => {
  const rootElement = document.documentElement;
  if (typeof cssVariables === 'object') {
    for (const key in cssVariables) {
      if (Object.hasOwn(cssVariables, key)) {
        if (!omitCssVariables.includes(key)) {
          rootElement.style.setProperty(`--${key}`, cssVariables[key]);
        }
      }
    }
  }
};

export const checkFormValidationStatus = (formInstance, formName) => {
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: TODO: fix
  return new Promise(async (resolve, reject) => {
    try {
      const validationStatus = await formInstance.validateFields();
      resolve({ [formName]: validationStatus });
    } catch (error) {
      reject({ formName, ...error });
    }
  });
};

export const convertThemeApiToLocal = (data) => {
  const results = {
    bottomMenuText: data?.bottomMenuTextColor,
    'dark-1': data?.bottomMenuColor,
    defaultDateFormat: data?.defaultDateFormat,
    'font-family': data?.fontFamily,
    fontSizePercent: data?.fontSize,
    header: data?.topMenuColor,
    preferedLanguage: data?.preferedLanguage,
    timeFormat: data?.timeFormat,
    topMenuText: data?.topMenuTextColor,
    [USER_PREFERENCES.SHIPMENT_VIEW_TYPE]: data[[USER_PREFERENCES.SHIPMENT_VIEW_TYPE]],
    [USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]: data[[USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]],
    [USER_PREFERENCES.LD_CLAIM_VIEW_TYPE]: data[[USER_PREFERENCES.LD_CLAIM_VIEW_TYPE]],
    [USER_PREFERENCES.OC_CLAIM_VIEW_TYPE]: data[[USER_PREFERENCES.OC_CLAIM_VIEW_TYPE]],
  };

  return filterNullishFromObject(results);
};

export const validateForm = (formInstance, formName) => {
  // eslint-disable-next-line no-async-promise-executor
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: TODO: fix
  return new Promise(async (resolve, reject) => {
    try {
      const validationStatus = await formInstance.validateFields();
      resolve({ [formName]: validationStatus });
    } catch (error) {
      reject({ formName, ...error });
    }
  });
};

export const hyphenOneToEmptyInObject = (object) => {
  if (object) {
    if (typeof object === 'object') {
      for (const key in object) {
        if (Object.hasOwn(object, key)) {
          // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
          if (object[key] == '-1') {
            object[key] = '';
          }
        }
      }
    }
  }
  return object;
};

export const validateShipmentNoVisibility = (approvalNo, status) =>
  String(approvalNo ? approvalNo : '').trim().length > 0 &&
  SHIPMENT_NO_HIDE_STATUSES.includes(String(status).toUpperCase());

export const generateStopNumbers = (n = 0, stopType) => {
  const options = [];

  if (typeof n === 'number') {
    for (let i = 1; i <= n; i++) {
      if (stopType === '2' && i === 1) {
        continue;
      }
      options.push({ label: i, value: i });
    }
  }

  return options;
};

export const checkIsPartialShipment = (status) => String(status).toUpperCase() === 'PARTIAL';

export const stopPropagation = (e) => {
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};

export const validateForms = (formInstance, formName) => {
  // eslint-disable-next-line no-async-promise-executor
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: TODO: fix
  return new Promise(async (resolve, reject) => {
    try {
      const validationStatus = await formInstance.validateFields();
      resolve({ [formName]: validationStatus });
    } catch (error) {
      reject({ formName, ...error });
    }
  });
};

export const downloadBlobFile = (blob, fileName, isBlob = true) => {
  const link = document.createElement('a');
  const url = isBlob ? window.URL.createObjectURL(blob) : blob;
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 1000);
};

export const getCollaboratorsPayload = (collaborators) =>
  collaborators.map((c) => ({
    emails: c.emails,
    group: c.group,
    notificationsEnabled: c.notificationsEnabled,
    userId: c.userId,
  }));

export const getCarriersPayload = (carriers) => {
  return carriers.reduce((acc, value) => {
    acc.push({
      carrierKey: value.carrierKey || value.carrierId,
      carrierName: value.carrierName || value.transportationProvider,
      Emails: value?.email || value?.Email,
      routingGuideId: value.routingGuideId,
    });

    return acc;
  }, []);
};

export const generateUPSPortalURL = (clientID) =>
  `${ENV_VARS.REACT_APP_RATE_UPS_AUTH}${clientID}&redirect_uri=${window.location.origin}/shipment/parcel-express&response_type=code&type=ups_com_api`;

export const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch {
    return false;
  }
};

export const getSmallParcelSelectedAccountNumberForUPS = ({ shipmentTerms, shipperAccountNo, upsAccount }) => {
  let accountNo;
  // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
  if (shipmentTerms == '3') {
    accountNo = shipperAccountNo;
  } else {
    accountNo = upsAccount;
  }
  return accountNo;
};

export const checkBidExpiryWithLastMinutes = (time, lastMinutes = 10) => {
  if (typeof time === 'string') {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds < lastMinutes * 60;
  }
  return false;
};
